module.exports = __webpack_public_path__ + "img/Marcos_Rivas.612c1788.jpg";